module.exports = __webpack_public_path__ + "static/img/08@2x.f7500fdf.png";